import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-sale2-icon',
  templateUrl: './shopping-sale2.component.html'
})
export class ShoppingSale2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
